import React, { SVGProps } from "react";

interface CodatLogoProps extends SVGProps<SVGSVGElement> {
  fillColor?: string;
}

const CodatLogo = ({
  fillColor = "currentColor",
  ...props
}: CodatLogoProps) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.37907 0.00814602L1.40857 2.48727C1.39756 2.50311 1.39172 2.52147 1.39172 2.5402C1.39172 2.55894 1.39756 2.5773 1.40857 2.59313L2.93347 3.53789C2.93742 3.54283 2.94259 3.54684 2.94857 3.54962C2.95455 3.55239 2.96116 3.55383 2.96787 3.55383C2.97458 3.55383 2.9812 3.55239 2.98717 3.54962C2.99315 3.54684 2.99833 3.54283 3.00227 3.53789L5.45038 2.00465C5.47289 2.00465 5.47289 1.98303 5.47289 1.96254V0.0707503C5.47289 0.00814602 5.42661 -0.0134809 5.37907 0.00814602Z"
        fill={fillColor}
      />
      <path
        d="M13.903 8.62363L8.54522 11.986C8.52145 12.0065 8.52145 12.0065 8.52145 12.0282V13.9404C8.52145 13.9826 8.5915 14.0247 8.61402 13.9826L13.9718 10.6201C13.9956 10.5996 13.9956 10.5996 13.9956 10.578V8.66575C14.0181 8.62363 13.9493 8.60314 13.903 8.62363Z"
        fill={fillColor}
      />
      <path
        d="M10.9933 8.49728C10.9973 8.50222 11.0024 8.50624 11.0084 8.50901C11.0144 8.51178 11.021 8.51323 11.0277 8.51323C11.0344 8.51323 11.041 8.51178 11.047 8.50901C11.053 8.50624 11.0582 8.50222 11.0621 8.49728L12.587 7.55253C12.5971 7.54709 12.6055 7.53935 12.6113 7.53007C12.6172 7.52079 12.6202 7.51029 12.6202 7.4996C12.6202 7.48891 12.6172 7.47841 12.6113 7.46913C12.6055 7.45984 12.5971 7.4521 12.587 7.44667L8.63779 4.96754C8.5915 4.94591 8.54522 4.96754 8.54522 5.00966V6.92193C8.54522 6.94242 8.54522 6.96405 8.56773 6.96405L10.9933 8.49728Z"
        fill={fillColor}
      />
      <path
        d="M0.0925701 3.68586C0.046285 3.66423 0 3.68586 0 3.72798V5.64025C0 5.66074 0 5.68237 0.022517 5.68237L5.37907 9.04365C5.38764 9.0493 5.39775 9.05269 5.4083 9.05345C5.41885 9.05421 5.42942 9.05231 5.43886 9.04796C5.4483 9.04361 5.45624 9.03697 5.4618 9.02878C5.46736 9.02059 5.47034 9.01116 5.47039 9.00153V7.08926C5.47039 7.06877 5.47039 7.04828 5.44787 7.04828L0.0925701 3.68586Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default CodatLogo;
